export default [
  //-------------------------------------
  //  CHILDREN EVENT
  //-------------------------------------
  {
    path: '/:directory/',
    name: 'Home',
    meta: { title: 'ホーム', eventRequired: true },
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/:directory/identity/confirm',
    name: 'ChildIdentityConfirm',
    meta: { title: '本人確認', authRequired: true, useVerify: true, isIdentitySms: true },
    component: () => import('../views/Identity/Confirm.vue'),
  },
  {
    path: '/:directory/identity/finish',
    name: 'ChildIdentityFinish',
    meta: { title: '本人確認', authRequired: true, useVerify: true, isIdentitySms: true },
    component: () => import('../views/Identity/Finish.vue'),
  },
  {
    path: '/:directory/login',
    name: 'Login',
    meta: { title: 'ログイン', unauthRequired: true },
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/:directory/sms/login',
    name: 'LoginSms',
    meta: { title: 'ログイン', unauthRequired: true, useLoginSms: true },
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/:directory/authentication',
    name: 'Authentication',
    meta: { title: '認証' },
    component: () => import('../views/Authentication.vue'),
  },
  //--SEARCH
  {
    path: '/:directory/search',
    name: 'Search',
    meta: { title: '店舗検索' },
    component: () => import('../views/Search/Index.vue'),
  },
  {
    path: '/:directory/search/result/shop',
    name: 'SearchShop',
    meta: { title: '検索結果' },
    component: () => import('../views/Search/Shop.vue'),
  },
  {
    path: '/:directory/search/result/coupon',
    name: 'SearchCoupon',
    meta: { title: 'クーポン一覧' },
    component: () => import('../views/Search/Coupon.vue'),
  },
  //--MYPAGE
  {
    path: '/:directory/mypage',
    name: 'Mypage',
    meta: { title: 'マイページ', authRequired: true },
    component: () => import('../views/Mypage/Index.vue'),
  },
  {
    path: '/:directory/mypage/userinfo',
    name: 'Userinfo',
    meta: { title: '会員情報', authRequired: true, notUseLinkageApp: true },
    component: () => import('../views/Mypage/Userinfo.vue'),
  },
  {
    path: '/:directory/mypage/transfer/cpm',
    name: 'TransferCpm',
    meta: { title: '自治体のロゴ', authRequired: true },
    component: () => import('../views/Mypage/TransferCpm/Index.vue'),
  },
  {
    path: '/:directory/mypage/history',
    meta: { title: 'ご利用履歴' },
    component: () => import('../views/Mypage/History.vue'),
    children: [
      {
        path: '',
        redirect: 'all',
      },
      {
        path: 'all',
        name: 'HistoryAll',
        meta: { title: 'すべて', authRequired: true, isHistory: true },
        component: () => import('../views/Mypage/HistoryAll.vue'),
      },
      {
        path: 'buy',
        name: 'HistoryBuy',
        meta: { title: '購入履歴', authRequired: true, isHistory: true },
        component: () => import('../views/Mypage/HistoryBuy.vue'),
      },
      {
        path: 'use',
        name: 'HistoryUse',
        meta: { title: '利用履歴', authRequired: true, isHistory: true },
        component: () => import('../views/Mypage/HistoryUse.vue'),
      },
    ],
  },
  {
    path: '/:directory/mypage/point/history',
    meta: { title: 'ポイント履歴' },
    component: () => import('../views/Mypage/History.vue'),
    children: [
      {
        path: '',
        redirect: 'all',
      },
      {
        path: 'all',
        name: 'PointHistoryAll',
        meta: { title: 'すべて', authRequired: true, isPointHistory: true  },
        component: () => import('../views/Mypage/Point/History.vue'),
      },
      {
        path: 'buy',
        name: 'PointHistoryBuy',
        meta: { title: '獲得履歴', authRequired: true, isPointHistory: true  },
        component: () => import('../views/Mypage/Point/History.vue'),
      },
      {
        path: 'use',
        name: 'PointHistoryUse',
        meta: { title: '利用履歴', authRequired: true, isPointHistory: true  },
        component: () => import('../views/Mypage/Point/History.vue'),
      },
    ],
  },
  {
    path: '/:directory/mypage/ticket/keyword',
    name: 'TicketKeyword',
    meta: { title: '認証', authRequired: true, eventRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Ticket/Keyword.vue'),
  },
  {
    path: '/:directory/mypage/ticket/confirm',
    name: 'TicketConfirm',
    meta: { title: '認証', authRequired: true, eventRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Ticket/Confirm.vue'),
  },
  {
    path: '/:directory/mypage/ticket/finish',
    name: 'TicketFinish',
    meta: { title: '認証', authRequired: true },
    component: () => import('../views/Mypage/Ticket/Finish.vue'),
  },
  {
    path: '/:directory/mypage/currency/keyword',
    name: 'CurrencyKeyword',
    meta: { title: '認証', authRequired: true, eventRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Currency/Keyword.vue'),
  },
  {
    path: '/:directory/mypage/currency/confirm',
    name: 'CurrencyConfirm',
    meta: { title: '認証', authRequired: true, eventRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Currency/Confirm.vue'),
  },
  {
    path: '/:directory/mypage/currency/finish',
    name: 'CurrencyFinish',
    meta: { title: '認証', authRequired: true },
    component: () => import('../views/Mypage/Currency/Finish.vue'),
  },
  {
    path: '/:directory/mypage/point/keyword',
    name: 'ChildPointKeyword',
    meta: { title: 'ポイント認証', authRequired: true, eventRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Point/Keyword.vue'),
  },
  {
    path: '/:directory/mypage/point/otp',
    name: 'ChildPointOtp',
    meta: { title: 'ポイント認証', authRequired: true, eventRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Point/Otp.vue'),
  },
  {
    path: '/:directory/mypage/point/confirm',
    name: 'ChildPointConfirm',
    meta: { title: 'ポイント認証', authRequired: true, eventRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Point/Confirm.vue'),
  },
  {
    path: '/:directory/mypage/point/finish',
    name: 'ChildPointFinish',
    meta: { title: 'ポイント認証', authRequired: true },
    component: () => import('../views/Mypage/Point/Finish.vue'),
  },
  {
    path: '/:directory/mypage/delete',
    name: 'Delete',
    meta: { title: '退会', authRequired: true, notUseLinkageApp: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Mypage/Delete.vue'),
  },
  {
    path: '/:directory/mypage/delete/finish',
    name: 'DeleteFinish',
    meta: { title: '退会', notUseLinkageApp: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Mypage/DeleteFinish.vue'),
  },
  {
    path: '/:directory/mypage/monitoring',
    name: 'Monitoring',
    meta: { title: 'みまもり設定', authRequired: true },
    component: () => import('../views/Mypage/Monitoring/Index.vue'),
  },
  {
    path: '/:directory/mypage/monitoring/:monitoringId/history',
    meta: { title: 'みまもり設定', authRequired: true },
    component: () => import('../views/Mypage/History.vue'),
    children: [
      {
        path: '',
        redirect: 'all',
      },
      {
        path: 'all',
        name: 'MonitoringHistoryAll',
        meta: { title: 'すべて', authRequired: true },
        component: () => import('../views/Mypage/HistoryAll.vue'),
      },
      {
        path: 'buy',
        name: 'MonitoringHistoryBuy',
        meta: { title: '購入履歴', authRequired: true },
        component: () => import('../views/Mypage/HistoryBuy.vue'),
      },
      {
        path: 'use',
        name: 'MonitoringHistoryUse',
        meta: { title: '利用履歴', authRequired: true },
        component: () => import('../views/Mypage/HistoryUse.vue'),
      },
    ],
  },
  {
    path: '/:directory/mypage/monitoring/entry',
    name: 'MonitoringEntry',
    meta: { title: 'みまもり設定', authRequired: true },
    component: () => import('../views/Mypage/Monitoring/Entry.vue'),
  },
  {
    path: '/:directory/mypage/monitoring/entry/id',
    name: 'MonitoringEntryID',
    meta: { title: 'みまもり設定', authRequired: true },
    component: () => import('../views/Mypage/Monitoring/EntryID.vue'),
  },
  {
    path: '/:directory/mypage/monitoring/entry/finish',
    name: 'MonitoringEntryFinish',
    meta: { title: 'みまもり設定', authRequired: true },
    component: () => import('../views/Mypage/Monitoring/EntryFinish.vue'),
  },
  {
    path: '/:directory/mypage/identity/confirm',
    name: 'IdentityConfirm',
    meta: { title: '本人確認', authRequired: true, useVerify: true },
    component: () => import('../views/Identity/Confirm.vue'),
  },
  {
    path: '/:directory/mypage/identity/finish',
    name: 'IdentityFinish',
    meta: { title: '本人確認', authRequired: true, useVerify: true },
    component: () => import('../views/Identity/Finish.vue'),
  },
  {
    path: '/:directory/mypage/sms',
    name: 'IdentitySMS',
    meta: { title: 'SMS認証', authRequired: true, useSms: true, isIdentitySms: true },
    component: () => import('../views/Mypage/SMS/IdentitySMS.vue'),
  },
  {
    path: '/:directory/mypage/sms/input',
    name: 'IdentityInputCodeSMS',
    meta: { title: 'SMS認証', authRequired: true, useSms: true, isIdentitySms: true  },
    component: () => import('../views/Mypage/SMS/IdentityInputCodeSMS.vue'),
  },
  {
    path: '/:directory/mypage/sms/finish',
    name: 'IdentitySmsFinish',
    meta: { title: 'SMS認証', authRequired: true, isIdentitySms: true },
    component: () => import('../views/Mypage/SMS/IdentitySmsFinish.vue'),
  },
  //--PAY
  {
    path: '/:directory/pay/barcode',
    name: 'PayBarcode',
    meta: { title: 'お支払い', authRequired: true, eventRequired: true, isPayment: true },
    component: () => import('../views/Pay/Index.vue'),
  },
  {
    path: '/:directory/pay',
    name: 'Pay',
    meta: { title: 'お支払い', authRequired: true, eventRequired: true, isPayment: true },
    component: () => import('../views/Pay/Index.vue'),
  },
  {
    path: '/:directory/pay/input',
    name: 'PayInput',
    meta: { title: 'お支払い', authRequired: true, eventRequired: true, isPayment: true },
    component: () => import('../views/Pay/Input.vue'),
  },
  {
    path: '/:directory/pay/confirm',
    name: 'PayConfirm',
    meta: { title: 'お支払い', authRequired: true, eventRequired: true, isPayment: true },
    component: () => import('../views/Pay/Confirm.vue'),
  },
  {
    path: '/:directory/pay/finish',
    name: 'PayFinish',
    meta: { title: 'お支払い', authRequired: true, isPayment: true },
    component: () => import('../views/Pay/Finish.vue'),
  },
  //--CHARGE
  {
    path: '/:directory/charge',
    name: 'Charge',
    meta: { title: 'チャージ', authRequired: true, eventRequired: true },
    component: () => import('../views/Charge/Index.vue'),
  },
  {
    path: '/:directory/charge/store/qr',
    name: 'ChargeStoreQr',
    meta: { title: 'チャージ', authRequired: true, eventRequired: true },
    component: () => import('../views/Charge/Store.vue'),
  },
  {
    path: '/:directory/charge/processing',
    name: 'ChargeProcessing',
    meta: { title: 'チャージ', authRequired: true, eventRequired: true },
    component: () => import('../views/Charge/Processing.vue'),
  },
  {
    path: '/:directory/convenience-store/finish',
    name: 'ConvenienceStoreFinish',
    meta: { title: 'コンビニ', authRequired: true },
    component: () => import('../views/Credit/Finish.vue'),
  },
  {
    path: '/:directory/payeasy/finish',
    name: 'PayeasyFinish',
    meta: { title: 'ペイジー', authRequired: true },
    component: () => import('../views/Credit/Finish.vue'),
  },
  //--CREDIT
  {
    path: '/:directory/credit',
    name: 'Credit',
    meta: { title: 'クレジットカード', authRequired: true, creditRequired: true },
    component: () => import('../views/Credit/Index.vue'),
  },
  {
    path: '/:directory/credit/finish',
    name: 'CreditFinish',
    meta: { title: 'クレジットカード', authRequired: true, creditRequired: true },
    component: () => import('../views/Credit/Finish.vue'),
  },
  {
    path: '/:directory/credit/register',
    name: 'CreditRegister',
    meta: { title: 'クレジットカード登録', authRequired: true, creditRequired: true },
    component: () => import('../views/Credit/Register.vue'),
  },
  {
    path: '/:directory/credit/registered',
    name: 'CreditRegistered',
    meta: { title: 'クレジットカード登録済み', creditRequired: true },
    component: () => import('../views/Credit/Registered.vue'),
  },
  {
    path: '/:directory/credit/bank',
    name: 'CreditBank',
    meta: { title: '銀行口座情報', authRequired: true, eventRequired: true },
    component: () => import('../views/Credit/Index.vue'),
  },
  {
    path: '/:directory/credit/bank/finish',
    name: 'CreditBankFinish',
    meta: { title: '銀行即時チャージ', authRequired: true },
    component: () => import('../views/Credit/Finish.vue'),
  },
  //--NEWS
  {
    path: '/:directory/news',
    meta: { title: 'お知らせ' },
    component: () => import('../views/News/Index.vue'),
    children: [
      {
        path: '',
        redirect: 'official',
      },
      {
        path: 'official',
        name: 'NewsOfficial',
        meta: { title: '事務局からのお知らせ' },
        component: () => import('../views/News/Official.vue'),
      },
      {
        path: 'shop',
        name: 'NewsShop',
        meta: { title: 'お店からのお知らせ' },
        component: () => import('../views/News/Shop.vue'),
      },
    ],
  },
  {
    path: '/:directory/news/:id/detail',
    name: 'NewsDetail',
    meta: { title: 'お知らせ' },
    component: () => import('../views/News/Detail.vue'),
  },
  //--ACCOUNT
  {
    path: '/:directory/account/entry/optional',
    name: 'EntryOptional',
    meta: { title: '自治体のロゴ', unauthRequired: true, eventRequired: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryOptional.vue'),
  },
  {
    path: '/:directory/account/entry/optional/qr',
    name: 'EntryOptionalQR',
    meta: { title: '自治体のロゴ', unauthRequired: true, eventRequired: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryOptionalQR.vue'),
  },
  {
    path: '/:directory/account/sms/entry',
    name: 'EntrySms',
    meta: { title: 'SMS認証', unauthRequired: true, eventRequired: true, authenticationRequired: true, isLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/Entry.vue'),
  },
  {
    path: '/:directory/account/sms/entry/confirm',
    name: 'EntrySmsConfirm',
    meta: { title: '入力内容確認', unauthRequired: true, isLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryConfirm.vue'),
  },
  {
    path: '/:directory/account/sms/entry/code',
    name: 'EntrySmsCode',
    meta: { title: '確認コード送信', unauthRequired: true, isLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryCode.vue'),
  },
  {
    path: '/:directory/account/sms/entry/input/confirm',
    name: 'EntrySmsInputConfirm',
    meta: { title: 'お客様情報入力', unauthRequired: true, isLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryInputConfirm.vue'),
  },
  {
    path: '/:directory/account/sms/entry/finish',
    name: 'EntrySmsFinish',
    meta: { title: '登録完了', unauthRequired: true, isLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryFinish.vue'),
  },
  {
    path: '/:directory/account/entry',
    name: 'Entry',
    meta: { title: '新規会員登録', unauthRequired: true, eventRequired: true, authenticationRequired: true, isNotLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/Entry.vue'),
  },
  {
    path: '/:directory/account/entry/confirm',
    name: 'EntryConfirm',
    meta: { title: '入力内容確認', unauthRequired: true, isNotLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryConfirm.vue'),
  },
  {
    path: '/:directory/account/entry/code',
    name: 'EntryCode',
    meta: { title: '確認コード送信', unauthRequired: true, isNotLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryCode.vue'),
  },
  {
    path: '/:directory/account/entry/input/confirm',
    name: 'EntryInputConfirm',
    meta: { title: 'お客様情報入力', unauthRequired: true, isNotLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryInputConfirm.vue'),
  },
  {
    path: '/:directory/account/entry/finish',
    name: 'EntryFinish',
    meta: { title: '登録完了', unauthRequired: true, isNotLoggedSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/EntryFinish.vue'),
  },
  {
    path: '/:directory/account/identity/confirm',
    name: 'AccountIdentityConfirm',
    meta: { title: '本人確認', useVerify: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Identity/Confirm.vue'),
  },
  {
    path: '/:directory/account/identity/finish',
    name: 'AccountIdentityFinish',
    meta: { title: '本人確認', useVerify: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Identity/Finish.vue'),
  },
  //--CONTACT
  {
    path: '/:directory/contact',
    name: 'ContactChild',
    meta: { title: 'お問い合わせ', eventRequired: true, isContactPage: true },
    component: () => import('../views/Contact/Index.vue'),
  },
  {
    path: '/:directory/contact/confirm',
    name: 'ContactChildConfirm',
    meta: { title: '入力内容確認', eventRequired: true, isContactPage: true },
    component: () => import('../views/Contact/Confirm.vue'),
  },
  {
    path: '/:directory/contact/finish',
    name: 'ContactChildFinish',
    meta: { title: '送信完了', eventRequired: true, isContactPage: true },
    component: () => import('../views/Contact/Finish.vue'),
  },
];
